import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IActTeamMemberActions, IThunkRestoreTeamMember } from '../types';

const onRestoreTeamMember: IThunkRestoreTeamMember = thunk(
  async ({ restoreTeamMember }: Actions<IActTeamMemberActions>, payload) => {
    const { clinicId, teamMemberId, actTeamId } = payload;

    await api.actTeamMember.restoreTeamMember(clinicId, actTeamId, teamMemberId);

    restoreTeamMember(teamMemberId);
  },
);

export default onRestoreTeamMember;
